import { ClearBetRaces, ClearBetByBetTypeAndRaces } from "../../Common/RacingBetline";
import { isStartSellpmPool, getPoolInvBetTypes } from "../../Common/Common";
export const parseSelSta = ( content, message, topicInfo) => {
    // also need to cater Top, Banker case
    let pmPools = content.meeting.pmPools.filter(x => x.oddsType.indexOf(topicInfo.oddsType)>=0 && x.leg.races[0]==topicInfo.raceNo);
    let poolInv = content.meeting.poolInvs.filter(x => x.oddsType == topicInfo.oddsType && x.leg.races[0] == topicInfo.raceNo)[0];

    if(message != null){
        if(message.sellList != null){
            if(poolInv != null) {
                poolInv.sellStatus = parseSellStat(message);
            }
            pmPools.forEach(pmPool => {
                pmPool.sellStatus = parseSellStat(message);
            });
        }
        if(message.st != null){
            if(poolInv != null) {
                poolInv.status = parsePoolStat(message);
            }
            pmPools.forEach(pmPool => {
                pmPool.status = parsePoolStat(message);
            });
        }
        if(poolInv != null) {
            if(!isStartSellpmPool(poolInv)) {
                let curPoolInvBetTypes = getPoolInvBetTypes(content)
                if(curPoolInvBetTypes.includes(poolInv.oddsType)){
                    if(poolInv.leg.races[0] == content.raceNo){
                        poolInv.leg.races.forEach(raceNo =>{
                            ClearBetByBetTypeAndRaces(poolInv.oddsType ,raceNo);
                        })

                    }else if(content.alupData.some(i => i.raceNo == poolInv.leg.races[0] )){
                        ClearBetByBetTypeAndRaces(poolInv.oddsType ,poolInv.leg.races[0])
                    }
                }
            }
        }
    }
}

const parseSellStat = (message)  => {
    let ab1 = message.sellList.filter(x => x.tote=='Ab1' && x.crsTyp=='On')[0];
    let ab2 = message.sellList.filter(x => x.tote=='Ab2' && x.crsTyp=='On')[0];
    return (ab1?.st=="StartSell" || ab2?.st=="StartSell") ? "START_SELL" : "STOP_SELL";
}

const parsePoolStat = (message)  => {
    switch ( message.st ) {
        case "StartSell":
            return "START_SELL";
        case "StopSell":
            return "STOP_SELL";
        case "RefundAfterClose":
            return "REFUND_AFTER_CLOSE";
        case "RefundBeforeClose":
            return "REFUND_BEFORE_CLOSE";
        case "ClosedAfterRefund":
            return "CLOSED_AFTER_REFUND";
    }
    return message.st.toUpperCase();
}